export function Dashboard() {
  return (
    <div className="flex-1">
      <h1>Dashboard</h1>
      <p>Seja bem-vindo ao programa de indicação!</p>
    </div>
  );
}